export type ChatState = {
	userId: string;
	username: string;
	userEmail: string;
	appName: string;
	appSupportEmail: string;
	appTeamName: string;
	chatOpen: boolean;
	isFirstTimeChatOpened: boolean;
	assistantTitle: string;
};

export const initialChatState = {
	userId: "",
	username: "",
	userEmail: "",
	appName: "",
	appSupportEmail: "",
	appTeamName: "",
	chatOpen: false,
	isFirstTimeChatOpened: true,
	assistantTitle: "",
} as ChatState;

export type ChatContextType = {
	chatState: ChatState;
	analyticsEnabled: boolean;
	setPartialChatState: (state: Partial<ChatState>) => void;
	pushContextMessage: (message: string) => void;
};
